import React, { useMemo } from 'react';
import { AppWindow, Radio } from 'lucide-react';
import { useSearchParams } from 'react-router-dom';
import { DashboardLayout } from '../../components/layout/DashboardLayout';
import { Tabs } from '../../components/ui/Tabs';
import { ReadyAppsSection } from '../../features/apps/ReadyAppsSection';
import { ActiveCloudDeployments } from '../../features/cloud/ActiveCloudDeployments';
import { PublishSlotsUsage } from '../../features/cloud/PublishSlotsUsage';
import { useI18n } from '../../hooks/useI18n';

export const CloudPage = () => {
  const { t } = useI18n();
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get('tab') === 'apps' ? 'apps' : 'live';

  const tabs = useMemo(
    () => [
      { value: 'live', label: t('cloudLiveTab'), icon: <Radio size={14} /> },
      { value: 'apps', label: t('cloudAppsTab'), icon: <AppWindow size={14} /> }
    ],
    [t]
  );

  const setTab = (nextTab) => {
    const nextParams = new URLSearchParams(searchParams);
    if (nextTab === 'live') {
      nextParams.delete('tab');
    } else {
      nextParams.set('tab', nextTab);
    }
    setSearchParams(nextParams, { replace: true });
  };

  return (
    <DashboardLayout title={t('homeServiceCloudTitle')}>
      <div className="space-y-6">
        <PublishSlotsUsage />
        <div className="flex sm:justify-end">
          <Tabs className="w-full sm:w-auto" tabClassName="flex-1 sm:flex-none" value={tab} onChange={setTab} tabs={tabs} />
        </div>

        {tab === 'apps' ? (
          <ReadyAppsSection />
        ) : (
          <ActiveCloudDeployments onOpenCatalog={() => setTab('apps')} />
        )}
      </div>
    </DashboardLayout>
  );
};
